"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryV2Builder = void 0;
var QueryV2Builder = /** @class */ (function () {
    function QueryV2Builder() {
        this.query = {};
    }
    QueryV2Builder.prototype.build = function () {
        return this.query;
    };
    QueryV2Builder.prototype.withQuery = function (q) {
        throw new Error('Method not implemented.');
    };
    QueryV2Builder.prototype.addSort = function (fieldName, order) {
        throw new Error('Method not implemented.');
    };
    QueryV2Builder.prototype.addPaging = function (limit, offset) {
        throw new Error('Method not implemented.');
    };
    QueryV2Builder.prototype.addFilter = function (filter) {
        if (filter) {
            this.query.filter = this.query.filter || {};
            Object.assign(this.query.filter, filter);
        }
        return this;
    };
    return QueryV2Builder;
}());
exports.QueryV2Builder = QueryV2Builder;
//# sourceMappingURL=QueryV2Builder.js.map